import { Button } from "@/components/ui/button";
import { useLocation } from "wouter";
import { Compass, Home, ArrowLeft } from "lucide-react";

export default function NotFound() {
  const [, setLocation] = useLocation();

  return (
    <div className="min-h-screen w-full flex items-center justify-center p-4">
      <div className="max-w-md w-full text-center space-y-8">
        <div className="relative">
          <div className="absolute inset-0 blur-3xl opacity-30 bg-gradient-to-r from-primary to-blue-500 rounded-full" />
          <div className="relative">
            <Compass className="h-32 w-32 mx-auto text-primary animate-spin-slow" />
          </div>
        </div>

        <div className="space-y-4">
          <h1 className="text-6xl font-bold bg-gradient-to-r from-primary to-blue-500 bg-clip-text text-transparent">
            404
          </h1>
          <h2 className="text-2xl font-bold">
            Oops! You're Off the Map! 🗺️
          </h2>
          <p className="text-muted-foreground text-lg">
            Looks like you've wandered into uncharted territory! This page doesn't exist, but don't worry: we'll help you find your way back.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button
            size="lg"
            onClick={() => setLocation("/")}
            className="gap-2"
            data-testid="button-home"
          >
            <Home className="h-5 w-5" />
            Back to Dashboard
          </Button>
          <Button
            size="lg"
            variant="outline"
            onClick={() => window.history.back()}
            className="gap-2"
            data-testid="button-back"
          >
            <ArrowLeft className="h-5 w-5" />
            Go Back
          </Button>
        </div>

        <p className="text-sm text-muted-foreground">
          Lost? Try navigating from the menu above! 🧭
        </p>
      </div>
    </div>
  );
}
